import create from 'zustand';

type Store = {
  isDeleteModal: boolean;
  deleteDataId: string[];
  searchKeyword: {
    category: string | undefined;
    kinds_vermin: string[] | undefined;
    start_date: string | undefined;
    end_date: string | undefined;
    occurrence_start: string | undefined;
    occurrence_stop: string | undefined;
  };
  deleteModalToggle: () => void;
  deleteModalClose: () => void;
  deleteDataInput: (data: string[], searchKeyword: object) => void;
};

/**
 * 詳細検索ボックスの開閉状態管理ストア
 */
const useDeleteModal = create<Store>(set => ({
  isDeleteModal: false,
  deleteDataId: [],
  searchKeyword: {
    category: undefined,
    kinds_vermin: undefined,
    start_date: undefined,
    end_date: undefined,
    occurrence_start: undefined,
    occurrence_stop: undefined,
  },
  deleteModalToggle: () => set(state => ({ isDeleteModal: !state.isDeleteModal })),
  deleteModalClose: () => set({ isDeleteModal: false }),
  deleteDataInput: (data: string[], searchKeyword: any) => set({ deleteDataId: data, searchKeyword: searchKeyword }),
}));

export default useDeleteModal;